/* unplugin-vue-components disabled */import script from "./OccupyManager.vue?vue&type=script&setup=true&lang=js"
export * from "./OccupyManager.vue?vue&type=script&setup=true&lang=js"

import "./OccupyManager.vue?vue&type=style&index=0&id=5794bbdd&lang=scss"

const __exports__ = script;

export default __exports__